module.exports = __webpack_public_path__ + "img/zaomuxuanzi.e6394ef6.jpg";